import { Ban, ShieldOff, Users, type LucideIcon } from 'lucide-react';
import { History } from 'lucide-react';

export interface Resumen {
  total: number;
  personas: number;
  porAccion: Record<string, number>;
}

export function ResumenDeAuditoria({ resumen }: { resumen: Resumen | undefined }) {
  const cuantas = (...acciones: string[]) =>
    acciones.reduce((suma, a) => suma + (resumen?.porAccion[a] ?? 0), 0);

  const fallidos = cuantas('entrada_fallida');
  const anulaciones = cuantas('anular_cobro', 'anular_factura');

  return (
    <div className="mb-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Cifra icono={History} rotulo="Registros" valor={resumen?.total} />
      <Cifra icono={Users} rotulo="Personas" valor={resumen?.personas} />
      <Cifra
        icono={ShieldOff}
        rotulo="Intentos fallidos"
        valor={fallidos}
        alerta={fallidos > 0}
      />
      <Cifra icono={Ban} rotulo="Anulaciones" valor={anulaciones} alerta={anulaciones > 0} />
    </div>
  );
}

function Cifra({
  icono: Icono,
  rotulo,
  valor,
  alerta = false,
}: {
  icono: LucideIcon;
  rotulo: string;
  valor: number | undefined;
  alerta?: boolean;
}) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-armazon-200 bg-white px-4 py-3">
      <span
        className={`grid size-9 shrink-0 place-items-center rounded-xl ${
          alerta ? 'bg-red-50 text-red-600' : 'bg-armazon-100 text-armazon-500'
        }`}
      >
        <Icono className="size-[18px]" aria-hidden />
      </span>
      <span className="min-w-0">
        <span
          className={`block text-xl font-bold tabular-nums leading-none ${
            alerta ? 'text-red-700' : 'text-armazon-800'
          }`}
        >

          {valor === undefined ? '—' : valor.toLocaleString('es-EC')}
        </span>
        <span className="mt-1 block truncate text-[10px] font-semibold uppercase tracking-wider text-armazon-400">
          {rotulo}
        </span>
      </span>
    </div>
  );
}
